<template>
  <div>
    <div class="content">
      <div class="title">零工身份申请填写表</div>
      <div class="cont">
        <div class="titleBox">
          <div class="shu"></div>
          <div class="name">基本信息</div>
        </div>
        <div class="box">
          <div class="name">姓名<span>*</span></div>
          <div class="inpBox">
            <div class="inp">
              <input type="text" v-model="name" placeholder="请输入姓名" />
            </div>
          </div>
        </div>
        <div class="box">
          <div class="name">联系方式<span>*</span></div>
          <div class="inpBox">
            <div class="inp">
              <input
                type="text"
                v-model="mobile"
                placeholder="请输入联系方式"
              />
            </div>
          </div>
        </div>
        <div class="box">
          <div class="name">服务时间<span>*</span></div>
          <div class="inpBox">
            <div class="inp">
              <input
                type="text"
                v-model="ling_time"
                placeholder="请输入服务时间，如：每周一至周日"
              />
            </div>
          </div>
        </div>
        <div class="box">
          <div class="name">个人介绍<span>*</span></div>
          <div class="textareaBox">
            <div class="textarea">
              <textarea
                v-model="ling_content"
                placeholder="请输入个人介绍"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="name">身份证照片<span>*</span></div>
          <div class="imgBox">
            <div class="img dis-cent" @click="uploadFile(3)">
              <div class="tupian" v-if="!imgRm">
                <div class="iconfont icon-camera"></div>
                <div class="txt">请上传人像面照片</div>
              </div>
              <div class="imgJt" v-if="imgRm">
                <img :src="$imgUrl + imgRm" alt="" />
              </div>
            </div>
            <div class="img dis-cent" @click="uploadFile(4)">
              <div class="tupian" v-if="!imgGh">
                <div class="iconfont icon-camera"></div>
                <div class="txt">请上传国徽面照片</div>
              </div>
              <div class="imgJt" v-if="imgGh">
                <img :src="$imgUrl + imgGh" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="titleBox">
          <div class="shu"></div>
          <div class="name">服务信息</div>
        </div>
        <div class="box">
          <div class="name">服务类型<span>*</span></div>
          <div class="selectCont">
            <div
              class="seLi dis-cent"
              :class="item.select ? 'on' : ''"
              v-for="(item, index) in gzTypeList"
              @click="gzTypeClick(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="box">
          <div class="name">服务地区<span>*</span></div>
          <div class="selectCont">
            <div
              class="seLi dis-cent"
              :class="item.select ? 'on' : ''"
              v-for="(item, index) in areaList"
              @click="areaClick(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="box">
          <div class="name">证书<span>*</span></div>
          <div class="imgBox">
            <div
              class="img dis-cent"
              v-if="imgs.length < 9"
              @click="uploadFile(2)"
            >
              <div class="iconfont icon-camera"></div>
            </div>
            <div class="img" v-for="(item, index) in imgs">
              <img :src="$imgUrl + item.path_name" alt="" />
              <div class="cha dis-cent" @click="imgDelClick(index)">
                <div class="iconfont icon-close"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gxBox">
        <div class="kuang dis-cent" :class="tyShow?'on':''" @click="tyClick">
          <div class="iconfont icon-right" v-if="tyShow"></div>
        </div>
        <div class="txt" :class="tyShow?'txtOn':''">我已阅读并同意 ”<span>《零工承诺书》</span>“</div>
      </div>
      <div class="btns">
        <!-- <div class="btn dis-cent">取消</div> -->
        <div class="btn dis-cent" @click="saveClick">提交</div>
      </div>
    </div>
    <input
      type="file"
      accept="image/*"
      ref="imgsfileInput"
      @change="onimgsFileChange"
      style="display: none"
    />
    <input
      type="file"
      accept="image/*"
      ref="sfzImgInput"
      @change="onsfzImgChange"
      style="display: none"
    />
    <input
      type="file"
      accept="image/*"
      ref="sfzGhImgInput"
      @change="onsfzGhImgChange"
      style="display: none"
    />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      imgs: [],
      gzTypeOn: null,
      gzTypeList: [],
      areaOn: "",
      areaList: [
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
          select: false,
        },
      ],
      ling_district: "",
      ling_district_cn: "",
      config_id: "",
      config_cn: "",
      name: "",
      mobile: "",
      ling_time: "",
      ling_content: "",
      memberinfo: {},
      imgRm: "",
      imgGh: "",
      tyShow: false,
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.get();
  },
  methods: {
    get() {
      this.$get("/nozzle/web/member_info").then((res) => {
        console.log(res);
        this.name = res.memberinfo.realname;
        this.mobile = res.memberinfo.phone;
        this.ling_time = res.memberinfo.ling_time;
        this.imgRm = res.memberinfo.cardz;
        this.imgGh = res.memberinfo.cardf;
        this.ling_content = res.memberinfo.ling_content;
        this.ling_district = res.memberinfo.ling_district.split(",");
        this.ling_district_cn = res.memberinfo.ling_district_cn.split(",");
        this.config_id = res.memberinfo.config_id.split(",");
        this.config_cn = res.memberinfo.config_cn.split(",");
        this.imgs = res.memberinfo.ling_resources
          ? res.memberinfo.ling_resources
          : [];
        this.memberinfo = res.memberinfo;
        this.areaListGet(res.memberinfo.ling_district_cn);
        this.typeGet(res.memberinfo.config_cn);
      });
    },
    areaListGet(data) {
      data = data.split(",");
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        for (let j = 0; j < this.areaList.length; j++) {
          const ej = this.areaList[j];
          if (ej.name == e) {
            ej.select = true;
          }
        }
      }
      this.areaList = this.areaList;
      this.$forceUpdate();
    },
    gzTypeClick(i) {
      this.gzTypeList[i].select = !this.gzTypeList[i].select;
      let config_id = [];
      let config_cn = [];
      for (let i = 0; i < this.gzTypeList.length; i++) {
        const e = this.gzTypeList[i];
        if (e.select) {
          config_id.push(e.id);
          config_cn.push(e.name);
        }
      }
      this.config_id = config_id;
      this.config_cn = config_cn;
    },
    areaClick(i) {
      this.areaList[i].select = !this.areaList[i].select;
      let ling_district = [];
      let ling_district_cn = [];
      for (let i = 0; i < this.areaList.length; i++) {
        const e = this.areaList[i];
        if (e.select) {
          ling_district.push(e.id);
          ling_district_cn.push(e.name);
        }
      }
      this.ling_district = ling_district;
      this.ling_district_cn = ling_district_cn;
    },
    typeGet(data) {
      this.$get("/common/configuration_gets", {
        type: "linggong",
      }).then((res) => {
        console.log(res);
        for (let i = 0; i < res.data.length; i++) {
          const e = res.data[i];
          e.select = false;
        }
        if (data) {
          data = data.split(",");
          for (let i = 0; i < data.length; i++) {
            const e = data[i];
            for (let j = 0; j < res.data.length; j++) {
              const ej = res.data[j];
              if (ej.name == e) {
                ej.select = true;
              }
            }
          }
        }
        this.gzTypeList = res.data;
      });
    },
    btns() {},
    imgDelClick(i) {
      this.imgs.splice(i, 1);
    },
    uploadFile(type) {
      if (type == 2) {
        this.$refs.imgsfileInput.click();
      }
      if (type == 3) {
        this.$refs.sfzImgInput.click();
      }
      if (type == 4) {
        this.$refs.sfzGhImgInput.click();
      }
    },
    onsfzImgChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgRm = res.data.data.path_name;
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    onsfzGhImgChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgGh = res.data.data.path_name;
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    onimgsFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgs.push(res.data.data);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    tyClick(){
      this.tyShow = !this.tyShow
    },
    saveClick() {
      let data = {};
      data.ling_district = this.ling_district.join(",");
      data.ling_district_cn = this.ling_district_cn.join(",");
      data.config_cn = this.config_cn.join(",");
      data.config_id = this.config_id.join(",");
      data.name = this.name;
      data.mobile = this.mobile;
      data.ling_time = this.ling_time;
      data.ling_content = this.ling_content;
      data.cardz = this.imgRm
      data.cardf = this.imgGh
      data.type = Number(this.type);
      let resource = [];
      for (let i = 0; i < this.imgs.length; i++) {
        const e = this.imgs[i];
        resource.push(e.id);
      }
      data.resource = resource.join(",");
      console.log(data);
      if (!data.name) {
        this.$message.error("请输入名字");
        return;
      }
      if (!data.mobile) {
        this.$message.error("请输入联系方式");
        return;
      }
      if (!data.ling_time) {
        this.$message.error("请输入服务时间");
        return;
      }
      if (!data.ling_content) {
        this.$message.error("请输入个人介绍");
        return;
      }
      if (!data.cardz||!data.cardf) {
        this.$message.error("请上传身份证照片");
        return;
      }
      if (!data.config_cn) {
        this.$message.error("请选择服务类型");
        return;
      }
      if (!data.ling_district_cn) {
        this.$message.error("请选择服务地区");
        return;
      }
      if (!data.resource) {
        this.$message.error("请选择证书");
        return;
      }
      data = JSON.stringify(data);
      this.$post("/nozzle/web/odd_apply", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("提交成功，等待审核通过");
          window.close();
          window.open("/#/user");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  border-radius: 10px;
  background-color: #fff;
  padding: 40px;
  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
  }
  .cont {
    padding: 20px 50px;
    padding-bottom: 0;
    .titleBox {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .shu {
        width: 4px;
        border-radius: 4px;
        height: 20px;
        background-color: #1382eb;
      }
      .name {
        font-weight: 600;
        font-size: 16px;
        margin-left: 10px;
      }
    }
    .box {
      margin-bottom: 30px;
      display: flex;
      .name {
        width: 100px;
        margin-top: 6px;
        span {
          color: #ee0909;
        }
      }
      .inpBox {
        width: calc(100% - 100px);
        height: 35px;
        .inp {
          width: 600px;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding-left: 15px;
          input {
            width: 100%;
            height: 100%;
          }
        }
      }
      .textareaBox {
        width: calc(100% - 100px);
        height: 200px;
        .textarea {
          width: 600px;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 10px 15px;
          textarea {
            width: 100%;
            height: 100%;
            border: none;
            resize: none;
          }
        }
      }
      .selectCont {
        overflow: hidden;
        .seLi {
          height: 35px;
          padding: 0 20px;
          border: 1px solid #d4d4d4;
          border-radius: 5px;
          color: #888;
          margin-right: 10px;
          margin-bottom: 10px;
          float: left;
          cursor: pointer;
        }
        .on {
          border: 1px solid #1382eb;
          background-color: #1382eb;
          color: #fff;
        }
      }
      .imgBox {
        display: flex;
        flex-wrap: wrap;
        width: calc(100% - 100px);
        .img {
          width: calc(25% - 11.25px);
          margin-right: 15px;
          height: 130px;
          border: 1px solid #ebebeb;
          color: #c9c9c9;
          cursor: pointer;
          margin-right: 15px;
          margin-bottom: 15px;
          cursor: pointer;
          position: relative;
          .tupian {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            height: 100%;
          }
          .iconfont {
            font-size: 30px;
          }
          .cha {
            position: absolute;
            top: 0;
            right: 0;
            width: 22px;
            height: 22px;
            border-bottom-left-radius: 5px;
            background-color: rgba(0, 0, 0, 0.4);
            color: #fff;
            cursor: pointer;
            .iconfont {
              font-size: 12px;
            }
          }
        }
        .img:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    .btn {
      margin-right: 30px;
      cursor: pointer;
      height: 40px;
      border-radius: 5px;
      width: 90px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
    }
    .btn:last-child {
      color: #fff;
      background-color: #1382eb;
      margin-right: 0;
    }
  }
}

.gxBox {
  padding-left: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
}

.gxBox .kuang {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid #cecece;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
}

.gxBox .txt {
  span{
    cursor: pointer;
  }
}

.gxBox .on{
  color: #fff;
  background-color: #1382eb;
  border: 1px solid #1382eb;
} 

.gxBox .txtOn{
  color: #1382eb;
}
</style>
